import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.4005 0.666565C9.41815 0.666565 7.00049 2.76523 7.00049 5.35406V45.9791C7.00049 48.5679 9.41815 50.6666 12.4005 50.6666C15.3828 50.6666 17.8005 48.5679 17.8005 45.9791V5.35406C17.8005 2.76523 15.3828 0.666565 12.4005 0.666565ZM37.6005 0.666565C34.6181 0.666565 32.2005 2.76523 32.2005 5.35406V45.9791C32.2005 48.5679 34.6181 50.6666 37.6005 50.6666C40.5828 50.6666 43.0005 48.5679 43.0005 45.9791V5.35406C43.0005 2.76523 40.5828 0.666565 37.6005 0.666565Z",
		fill: "#002938"
	})
});
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
